import React, {Component} from 'react';
import {cloneDeep, get} from 'lodash';
import classnames from 'classnames';

import PropTypes from 'prop-types';

// Actions
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {push} from '../actions/router-actions';

// Radar UI components
import Form from '../components-core/form';
import Loading from '../components-core/loading';
import ManageShelfList from '../components-core/manage-shelf-list';
import searchHoc from './search-wrapper';

import * as shelfActions from '../actions/shelf-actions';

// PrimeReact styles
import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

const servicesDataKey = 'loadSubShelves';

class ManageShelves extends Component {
    state = {
        parentShelfId: this.props.match.params.parentshelfid, // eslint-disable-line react/destructuring-assignment
    };

    UNSAFE_componentWillUpdate(nextProps) {
        const {fetching, history} = this.props;
        const {error} = this.state;
        
        if (nextProps.error && error !== nextProps.error) {
            this.setState({error: nextProps.error});
        } else if (fetching && !nextProps.fetching) {
            this.setState({}, () => {
                history.goBack();
            });
        }
    }

    getSearchValues() {
        return get(this.props, 'searchData.ShelfDTO.subShelves', {});
    }

    getClass() {
        const {className} = this.props;

        return classnames(className, 'main-nav');
    }

    getManageShelfListProps() {
        const {parentShelfId} = this.state;

        return {
            parentShelfId,
            shelvesList: this.getSearchValues(),
        };
    }

    deleteShelves = shelvesToDelete => {
        const {searchData, removeShelves} = this.props;

        /*
         * Order of delete operation here is VITAL otherwise the
         * Catalog DB becomes corrupt:
         *
         * 1. Remove the shelf from it's parent's subShelves
         * 2. Only then send HTTP DELETE method with the shelfId to delete
         *
         */
        if (searchData) {
            const shelfObj = cloneDeep(searchData);
            let launchIdPresentInSelection = false;

            // Remove references to shelf from it's parent's subShelves
            shelvesToDelete.forEach(element => {
                // Added another check before sending shelves for deletion.
                launchIdPresentInSelection = launchIdPresentInSelection || !!element.ShelfDTO.launchId;
                shelfObj.ShelfDTO.subShelves = shelfObj.ShelfDTO.subShelves.filter(
                    tag => tag.ShelfDTO.id !== element.ShelfDTO.id
                );
            });

            if (launchIdPresentInSelection)
                this.setState({error: "Can't delete a shelf when a launch id is present"}, () => removeShelves());
            else this.setState({error: null}, () => removeShelves(shelfObj, shelvesToDelete));
        }
    };

    render = () => {
        const {fetching} = this.props;

        return (
            <Form>
                <br />
                <ManageShelfList
                    {...this.getManageShelfListProps()}
                    deleteShelves={this.deleteShelves}
                    id="managelist"
                    name="managelist"
                />

                <Loading loading={fetching} />
            </Form>
        );
    };
}

ManageShelves.propTypes = {
    className: PropTypes.object,
    removeShelves: PropTypes.func.isRequired,
    error: PropTypes.string,
    fetched: PropTypes.bool,
    fetching: PropTypes.bool,
    history: PropTypes.object,
    mapping: PropTypes.bool,
    match: PropTypes.object.isRequired,
    push: PropTypes.func.isRequired,
    routerParams: PropTypes.object,
    searchData: PropTypes.array.isRequired,
    submitted: PropTypes.bool,
};

function mapStateToProps(state) {
    return {...state.updateShelf};
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({...shelfActions, push}, dispatch);
}

export default searchHoc(connect(mapStateToProps, mapDispatchToProps)(ManageShelves), servicesDataKey);
